import { action, observable } from 'mobx';
import { App } from './App';

class AppFactory {
  @observable.ref accessor app: App | null = null;

  @action
  createApp(): App {
    this.app = new App();
    return this.app;
  }
}

export const appFactory = new AppFactory();
